export default __webpack_public_path__ + "static/media/Group 33439.18bf0e49.png";